// @flow

// Libs
import React from 'react'
import InlineSVG from 'svg-inline-react'

type Props = {
  src: string | number,
  size?: number,
  height?: number,
  width?: number,
  color?: string,
  style?: Object,
}

export const SvgIcon = ({src, size = 24, height, width, color, style = {}}: Props): React.Element<any> => (
  <div
    data-test='fc-icons/SvgIcon'
    style={{
      display: 'inline-block',
      height: height || size,
      width: width || size,
      ...style,
    }}
  >
    <InlineSVG
      src={src}
      style={{
        display: 'block',
        fill: color || 'initial',
      }}
    />
  </div>
)

export default SvgIcon
